import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
    const { user } = useAuth();
    const [ids, setIds] = useState([]);

    useEffect(() => {
        if (user) {
            api.get("/favorites/ids")
                .then((res) => setIds(res.data))
                .catch(() => setIds([]));
        } else {
            setIds([]);
        }
    }, [user]);

    const isFavorite = (id) => ids.includes(id);

    const toggle = async (id) => {
        if (isFavorite(id)) {
            await api.delete(`/favorites/${id}`);
            setIds((prev) => prev.filter((x) => x !== id));
            return false;
        }
        await api.post(`/favorites/${id}`);
        setIds((prev) => [...prev, id]);
        return true;
    };

    return (
        <FavoritesContext.Provider value={{ ids, isFavorite, toggle }}>
            {children}
        </FavoritesContext.Provider>
    );
}

export function useFavorites() {
    return useContext(FavoritesContext);
}
